import React, { useContext, useState } from 'react'
import { StoresContext } from '@App/contexts'
import { action } from 'mobx'
import { observer } from 'mobx-react'
import { IPIValidator } from '@App/helpers/validate'
import RadioSelectionTab from '@Components/WorkRegistrationSubs/AddWriter/RadioSelectionTab'
import { WriterFormType } from '@App/enum/writer-form-type'
import './index.scss'
import SearchWithAutoComplete from '@Components/Search/SearchWithAutoComplete'
import getWriterNameAutoCompleteSuggestions from '@App/helpers/search/get-writer-name-auto-complete-suggestions'
import WriterResults from '@Components/WorkRegistrationSubs/AddWriter/WriterResults'
import { WriterModel } from '@Entities/work/writer-model'

interface WriterAddFormProps {
    setFoundWriterToDraft: (writer: WriterModel, closePopup: boolean) => void
    onRadioButtonClicked: () => void
    expanded?: boolean
    expandedChanged?: (changeTo: WriterFormType) => void
}

const WriterAddForm = ({
    setFoundWriterToDraft,
    onRadioButtonClicked,
    expanded,
    expandedChanged,
}: WriterAddFormProps) => {
    const { writerSearchStore } = useContext(StoresContext)

    const [searchWasPerformed, setSearchWasPerformed] = useState(false)

    const onSubmitSearch = action(async (value: string) => {
        if (IPIValidator(value, true)) {
            writerSearchStore.setWriterSearch({
                ipiNameNumber: value,
            })
        } else {
            writerSearchStore.setWriterSearch({
                fullName: value,
            })
        }
        await writerSearchStore.searchWriters()
        setSearchWasPerformed(true)
    })

    const onClear = () => {
        writerSearchStore.clearStore()
        setSearchWasPerformed(false)
    }

    const writersSearchModelHasData =
        writerSearchStore.writersSearchModel && writerSearchStore.writersSearchModel.count > 0

    const SearchIsLoadingText = () => <p>Searching, please wait...</p>

    return (
        <div className="writer-add-form">
            <h2>Add Writer</h2>

            <RadioSelectionTab
                id="search-for-writer-tab"
                name="Search for a writer"
                onClick={onRadioButtonClicked}
                defaultChecked
                forceChecked={expanded}
            >
                <div className="writer-sub-form-component">
                    <SearchWithAutoComplete
                        id="writer-search"
                        placeholder="Search writer's name or IPI Number"
                        buttonClick={async (value) => {
                            if (expandedChanged) {
                                expandedChanged(WriterFormType.add)
                            }
                            await onSubmitSearch(value)
                        }}
                        onClearInput={onClear}
                        searchFieldClicked={onRadioButtonClicked}
                        autoCompleteFetcher={getWriterNameAutoCompleteSuggestions}
                        autoCompleteField="fullName"
                    />

                    {expanded &&
                        (writerSearchStore.isSearching ? (
                            <SearchIsLoadingText />
                        ) : (
                            writersSearchModelHasData && <WriterResults setFoundWriterToDraft={setFoundWriterToDraft} />
                        ))}

                    {searchWasPerformed && !writersSearchModelHasData && (
                        <div className="suggested-title">Not found</div>
                    )}
                </div>
                {searchWasPerformed && expanded && (
                    <div className="suggested-title">Can&apos;t find what you&apos;re looking for?</div>
                )}
            </RadioSelectionTab>
        </div>
    )
}

export default observer(WriterAddForm)
